module.exports = __webpack_public_path__ + "img/13.350f2267.jpg";